import * as R from 'ramda'

const capitalize = R.compose(
  R.join(''),
  R.juxt([
    R.compose(R.toUpper, R.head),
    R.tail
  ])
)

const toJSON = (str) => {
    try {
        return JSON.parse(str)
    } catch(e) {
        return null
    }
}

// similar to Object.assign, with deep assignments
function objAssign (target, ...sources) {
  sources.forEach(source => {
    Object.keys(source).forEach(key => {
      const s_val = source[key]
      const t_val = target[key]
      target[key] = t_val && s_val && typeof t_val === 'object' && typeof s_val === 'object'
                  ? objAssign(t_val, s_val)
                  : s_val
    })
  })
  return target
}

function shallowEqual(objA, objB) {
  if (objA === objB) {
    return true
  }

  if (typeof objA !== 'object' || objA === null ||
      typeof objB !== 'object' || objB === null) {
    return false
  }

  var keysA = Object.keys(objA)
  var keysB = Object.keys(objB)

  if (keysA.length !== keysB.length) {
    return false
  }

  // Test for A's keys different from B.
  var bHasOwnProperty = hasOwnProperty.bind(objB)
  for (var i = 0; i < keysA.length; i++) {
    // if (objA[keysA[i]] !== undefined || objB[keysA[i]] !== undefined ){
      if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
        return false
      }
    // }
  }

  return true
}


function shallowCompare (instance, nextProps) {
  return (
    !shallowEqual(instance, nextProps)
  )
}

function getQueryVariable(variable)
{
       var query = window.location.search.substring(1)
       var vars = query.split('&')
       for (var i=0;i<vars.length;i++) {
               var pair = vars[i].split('=')
               if(pair[0] == variable){return pair[1]}
       }
       return(false)
}

function removeQueryParam(key) {
  let url = new URL(window.location.href)
  url.searchParams.delete(key)
  window.history.pushState({}, document.title, url)
}

function getFileBasename(filename) {
  return filename.replace(/\.[^/.]+$/, '')
}

export {
    capitalize,
    toJSON,
    objAssign,
    shallowEqual,
    shallowCompare,
    getQueryVariable,
    removeQueryParam,
    getFileBasename
}
